export default __webpack_public_path__ + "static/media/Darts.e89a11a5.svg";